import React from 'react';
import styles from './styles/Keys.module.css';

/**
 * A situation or choice that uses a key, as a link: clicking it opens that item's
 * Keys tab and brings it into view.
 *
 * @param {{
 *   kind: 'situation'|'choice',
 *   id: string,
 *   title?: string,
 *   onJump: (kind: 'situation'|'choice', id: string) => void,
 * }} props
 */
const KeyUsageChip = ({ kind, id, title, onJump }) => {
    const label = title?.trim() || 'Untitled';
    const kindLabel = kind === 'situation' ? 'Situation' : 'Choice';
    return (
        <button
            type="button"
            className={styles.usageChip}
            onClick={() => onJump(kind, id)}
            title={`${kindLabel}: ${label} (click to open)`}
        >
            <span className={`${styles.usageKind} ${kind === 'situation' ? styles.usageKindSituation : ''}`}>
                {kind === 'situation' ? 'S' : 'C'}
            </span>
            <span className={styles.usageTitle}>{label}</span>
        </button>
    );
};

export default KeyUsageChip;
